import { post } from '@private-crm-app/requests/api';

export async function createPortalSessionHandoff(
  privateAppToken: string,
  portalReturnUrl: string
): Promise<{ code: string }> {
  return post<{ code: string }>({
    url: 'citizen-portal/session-handoff',
    data: { portalReturnUrl },
    headers: {
      Authorization: `Bearer ${privateAppToken}`,
    },
    isAuthToken: false,
    redactTransportLogs: true,
  });
}

export function buildPortalSessionCallbackUrl(portalReturnUrl: string, code: string): string {
  const callback = new URL('/api/auth/citizen/callback', new URL(portalReturnUrl).origin);
  callback.searchParams.set('code', code);
  callback.searchParams.set('returnTo', portalReturnUrl);

  return callback.toString();
}
